import React, { PropsWithChildren } from "react"

type Props = {
  appId: string;
  refetchAppDetails: () => void,
}

export const TemporaryShutdown: React.FC<PropsWithChildren<Props>> = (props: Props) => {
  return <div className="paper saas-temporary-shutdown">
    <h3 className="title">Account Paused</h3>
    <p>We noticed that no users have been created in the last 30 days with your SuperTokens instance. 
      You can reactivate the instance using the button below or email us at support@supertokens.com. All the data previously created will be available.</p><br/>
      <a href="mailto:support@supertokens.com?subject=Request%20for%20reactivation%20of%20SuperTokens%20instance&body=Hi%20SuperTokens%20Team%2C%0A%0AI%20would%20like%20to%20reactivate%20my%20SuperTokens%20account.%0A%0ABest%2C" target="_blank">Reactivate Now</a>
  </div>
}